import { Link } from "react-router-dom";
import { useStore } from "@/context/StoreContext";
import { img } from "@/lib/api";
import { Cta } from "@/components/Cta";
import { Price } from "@/components/ProductBits";
import { Reveal } from "@/components/Reveal";

export const ProductStory = () => {
  const { site, products } = useStore();
  const s = site.story;
  const p = products.find((x) => x.id === s.product_id) || products.find((x) => x.featured) || products[0];
  if (!p) return null;
  return (
    <section data-testid="product-story-section" className="bg-emerald-deep text-pearl py-16 lg:py-24 relative overflow-hidden grain">
      <div className="container-rh grid lg:grid-cols-12 gap-12 lg:gap-20 items-center relative">
        <Reveal className="lg:col-span-7 relative">
          <div className="relative w-fit max-w-full mx-auto">
            <Link to={`/product/${p.slug}`} className="block rounded-[28px] overflow-hidden">
              <img src={img(s.image || p.images[0])} alt={p.name} loading="lazy" className="fit-view" data-testid="product-story-image" />
            </Link>
            {s.image2 && (
              <Link to={`/product/${p.slug}`} data-testid="product-story-small-image" className="hidden sm:block absolute -bottom-8 -right-6 lg:-right-28 w-44 lg:w-60 rounded-[22px] overflow-hidden border-[6px] border-emerald-deep bg-white shadow-[0_24px_50px_-20px_rgba(0,0,0,.5)]">
                <img src={img(s.image2)} alt={`${p.name} full view`} loading="lazy" className="block w-full h-auto hover:scale-105 transition-transform duration-700" />
              </Link>
            )}
          </div>
        </Reveal>
        <Reveal delay={0.1} className="lg:col-span-5">
          <p className="eyebrow text-champagne flex items-center gap-3"><span className="w-10 h-px bg-current" />The hero piece</p>
          <h2 className="font-display font-medium text-[42px] sm:text-[56px] lg:text-[64px] leading-[0.98] mt-6" data-testid="product-story-heading">{s.heading}</h2>
          <p className="mt-7 text-[18px] leading-relaxed text-pearl/80">{s.text || p.story}</p>
          <div className="mt-10 pt-8 border-t border-pearl/15 space-y-3">
            <p className="font-display text-[30px] font-semibold leading-tight">{p.name}</p>
            <Price p={p} light />
          </div>
          <div className="mt-9">
            <Cta to={`/product/${p.slug}`} label={s.cta} variant="pearl" size="lg" testId="product-story-cta" />
          </div>
        </Reveal>
      </div>
    </section>
  );
};
